import React from "react";
import { Home, Building2, Warehouse, Users, FileSignature } from "lucide-react";
import { HOW_IT_WORKS } from "../../mock/mockData";

const TAG_ICONS = { Maison: Home, Appartement: Building2, Parking: Warehouse, Locataires: Users, Colocataires: Users, "Contrat de location": FileSignature };

export default function HowItWorks() {
  return (
    <section id="tour" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-brand-limeDark font-semibold mb-3">Un fonctionnement simple</p>
          <h2 className="font-display text-4xl lg:text-5xl font-semibold text-brand-greenDeep">Démarrez en 3 étapes</h2>
          <p className="mt-4 text-lg text-brand-green/60">Ajoutez votre bien, votre locataire, puis créez la location.</p>
        </div>

        <div className="space-y-6">
          {HOW_IT_WORKS.map((s, idx) => (
            <div
              key={s.step}
              className={`grid lg:grid-cols-2 gap-8 items-center rounded-3xl p-8 lg:p-12 ${idx % 2 === 0 ? "bg-brand-softer" : "bg-brand-soft"}`}
            >
              <div className={idx % 2 === 0 ? "" : "lg:order-2"}>
                <div className="flex items-center gap-4 mb-5">
                  <span className="w-12 h-12 rounded-full bg-brand-lime flex items-center justify-center font-display text-lg font-bold text-brand-greenDeep">{s.step}</span>
                  <h3 className="font-display text-3xl font-semibold text-brand-greenDeep">{s.title}</h3>
                </div>
                <div className="flex flex-wrap gap-3 mb-5">
                  {s.tags.map((t) => {
                    const Icon = TAG_ICONS[t] || Home;
                    return (
                      <span key={t} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white text-brand-green font-medium text-sm shadow-sm">
                        <Icon className="w-4 h-4 text-brand-limeDark" /> {t}
                      </span>
                    );
                  })}
                </div>
                <p className="text-brand-green/70 leading-relaxed text-lg">{s.desc}</p>
              </div>
              <div className={idx % 2 === 0 ? "" : "lg:order-1"}>
                <div className="bg-white rounded-2xl shadow-lg p-6 border border-white">
                  <p className="text-sm font-semibold text-brand-greenDeep mb-4">Étape {s.step}</p>
                  <div className="space-y-3">
                    <div className="h-3 w-3/4 rounded-full bg-brand-soft" />
                    <div className="h-10 rounded-lg bg-brand-softer border border-brand-soft" />
                    <div className="h-10 rounded-lg bg-brand-softer border border-brand-soft" />
                    <div className="flex justify-end pt-2">
                      <span className="px-5 py-2 rounded-lg bg-brand-lime text-brand-greenDeep font-semibold text-sm">Enregistrer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <p className="text-center mt-10 text-brand-green/70 text-lg max-w-2xl mx-auto">Ensuite, vos quittances et vos suivis se génèrent automatiquement chaque mois.</p>
      </div>
    </section>
  );
}
